import { ReactNode } from 'react';

import styles from './DescriptionList.module.css';

export const DescriptionList = ({
  label,
  value,
  isCapitalized,
}: {
  label: string;
  value?: number | string | ReactNode;
  isCapitalized?: boolean;
}) => (
  <dl className={styles.infoItem}>
    <dt className={styles.label}>{label}</dt>
    <dd className={`${styles.value} ${isCapitalized ? styles.capitalizedName : ''}`}>{value}</dd>
  </dl>
);
